import { useAtomValue, useSetAtom } from 'jotai';
import { comparisonTeamRadarFilterDebounceObject } from '@/atoms/queries/team/teamComparison';
import { unwrappedComparisonTeamSelectedGamesForQueryAtom } from '@/atoms/queries/team/teamComparisonGames';
import { teamComparisonEventFilterDebounceObject } from '@/atoms/queries/team/teamEventDataComparison';
import { DEFAULT_DEBOUNCE_MS } from '@/consts/api';
import { useDeepEffect } from '../useDeepEffect';

export const useSetTeamComparisonDebouncedFilterParams = () => {
  const gameIds = useAtomValue(unwrappedComparisonTeamSelectedGamesForQueryAtom);

  const { debouncedValueAtom: comparisonTeamRadarFilterAtom, timeoutDelayAtom: comparisonTeamRadarTimeoutDelayAtom } =
    comparisonTeamRadarFilterDebounceObject;
  const setComparisonTeamRadarFilter = useSetAtom(comparisonTeamRadarFilterAtom);
  const setComparisonTeamRadarFilterTimeoutDelay = useSetAtom(comparisonTeamRadarTimeoutDelayAtom);

  const { debouncedValueAtom: comparisonTeamEventFilterAtom, timeoutDelayAtom: comparisonTeamEventTimeoutDelayAtom } =
    teamComparisonEventFilterDebounceObject;
  const setComparisonTeamEventFilter = useSetAtom(comparisonTeamEventFilterAtom);
  const setComparisonTeamEventFilterTimeoutDelay = useSetAtom(comparisonTeamEventTimeoutDelayAtom);

  const updateTimeouts = (timeout: number) => {
    setComparisonTeamRadarFilterTimeoutDelay(timeout);
    setComparisonTeamEventFilterTimeoutDelay(timeout);
  };

  useDeepEffect(() => {
    // If there's no games, set the timeout to 0 as this won't trigger an API call.
    if (!gameIds.length) {
      updateTimeouts(0);
    }
    setComparisonTeamRadarFilter({ in: { game_id: gameIds } });
    setComparisonTeamEventFilter(gameIds.length ? { in: { 'event.game_id': gameIds } } : null);
    // If there were games this time, set the timeout so that we debounce subsequent calls
    if (gameIds.length) {
      updateTimeouts(DEFAULT_DEBOUNCE_MS);
    }
  }, [gameIds]);
};
